import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function signixNameFieldValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value: string = control.value ?? '';

    if (!value) {
      return null;
    }

    return /^[a-zA-Z0-9]+$/.test(value) ? null : { signixNameField: true };
  };
}
